<template>
    <b-modal id="delete_client_modal" ref="bvModal">
        <template v-slot:modal-header>
            <div class="modal-header-buttons-container">
                <h4>{{ $t("deleteClientModal.title") }}</h4>
                <button
                    class="close-modal-btn"
                    @click="closeDeleteClientModal()"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="feather feather-x"
                    >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>
        </template>
        <p class="confirmation-message">
            {{ confirmationMessage }}
        </p>
        <template v-slot:modal-footer>
            <div class="modal-footer-buttons-container">
                <button
                    class="ml-4 bb-btn btn-secondary"
                    @click="closeDeleteClientModal()"
                >
                    {{ $t("deleteClientModal.cancelBtn") }}
                </button>
                <button class="ml-4 bb-btn btn-danger" @click="deleteClient()">
                    {{ $t("deleteClientModal.confirmBtn") }}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { SET_ALERT_MESSAGES } from "@/core/services/store/alert.module.js";
import httpService from "@/core/services/http.service.js";
import { EventBus } from "@/core/services/event-bus.js";

export default {
    name: "DeleteClientModal",
    data() {
        return {
            client: null,
            successCallback: null,
            errorCallback: null,
        };
    },
    methods: {
        /**
         * Reset component data
         * @return {void}
         */
        reset() {
            this.client = null;
            this.successCallback = null;
            this.errorCallback = null;
        },

        /**
         * Close the modal
         * @return {void}
         */
        closeDeleteClientModal() {
            this.reset();
            this.$refs.bvModal.hide();
        },

        /**
         * Handle deletingClient event
         * @param {Object} client
         * @return {void}
         */
        handleDeletingClient(event) {
            this.client = event.client;
            this.successCallback = event.successCallback;
            this.errorCallback = event.errorCallback;
            if (this.client) {
                this.$refs.bvModal.show();
            }
        },

        /**
         * Send http request to delete client
         * @return {void}
         */
        deleteClient() {
            httpService
                .delete("/api/b2b/client-profiles/" + this.client.id)
                .then((response) => {
                    this.$store.dispatch(SET_ALERT_MESSAGES, {
                        successMessages: [response.data.message],
                        errorMessages: null,
                    });
                    if (this.successCallback) {
                        this.successCallback();
                    }
                    this.closeDeleteClientModal();
                })
                .catch((error) => {
                    this.$store.dispatch(SET_ALERT_MESSAGES, {
                        successMessages: null,
                        errorMessages: [error.response.data.message],
                    });
                    if (this.errorCallback) {
                        this.errorCallback();
                    }
                    this.closeDeleteClientModal();
                });
        },
    },
    computed: {
        confirmationMessage() {
            return (
                this.$t("deleteClientModal.message") +
                " " +
                this.client?.fullName +
                "?"
            );
        },
    },
    mounted() {
        EventBus.$on("deletingClient", this.handleDeletingClient);
    },
    destroyed() {
        EventBus.$off("deletingClient", this.handleDeletingClient);
    },
};
</script>
<style lang="scss">
@import "@/assets/sass/bb-styles/modals/delete-client-modal.scss";
</style>
